import { DateTimeInput } from '@components/DateTimeInput'
import { DateTimeInputFieldProps } from './interface'

export function DateTimeInputField(props: DateTimeInputFieldProps) {
  return <DateTimeInput {...props} />
}
